import stylesMixins from '../styles/mixins.module.scss';

export const MOBILE_MEDIA_QUERY = `(max-width: ${stylesMixins.MOBILE_MAX_WIDTH})`;
export const TABLET_MEDIA_QUERY = `(min-width:${stylesMixins.TABLET_MIN_WIDTH}) and (max-width:${stylesMixins.TABLET_MAX_WIDTH})`;
export const DESKTOP_MEDIA_QUERY = `(min-width:${stylesMixins.DESKTOP_MIN_WIDTH})`;
